import { z } from "zod";

/**
 * path: ルーティングのパス
 * category: Backendが要求するカテゴリ
 */
export const AppsAlertType = {
  shadowIt: {
    key: "shadowIt",
    path: "shadow-it/apps",
    category: "SHADOW_IT",
  },
  noWorker: {
    key: "noWorker",
    path: "no-worker",
    category: "NO_WORKER",
  },
  violatedAssignment: {
    key: "violatedAssignment",
    path: "violated-assignment",
    category: "VIOLATED",
  },
  violatedRole: {
    key: "violatedRole",
    path: "violated-role",
    category: "VIOLATED_ROLE",
  },
  noUser: {
    key: "noUser",
    path: "no-user",
    category: "NO_USER",
  },
  inactive: {
    key: "inactive",
    path: "inactive-user",
    category: "INACTIVE",
  },
} as const;

export type AppsAlertCategory =
  (typeof AppsAlertType)[keyof typeof AppsAlertType]["category"];
export type AppsAlertType = keyof typeof AppsAlertType;

export const SearchSchema = z.object({
  page: z.number().optional(),
  pageSize: z.number().optional(),
  sortBy: z.string().optional(),
  sortOrder: z.enum(["asc", "desc"]).optional(),
});

export type SearchParams = z.infer<typeof SearchSchema>;
